import Airtable from "airtable";

Airtable.configure({
  endpointUrl: "https://api.airtable.com",
  apiKey:
    "patZVy9c0JOBzwFOU.0600e75d034be9bb65d2b44fe640ca0da148907e261247a8d1d5213df661c633",
});

export const base = new Airtable({
  endpointUrl: "https://api.airtable.com",
  apiKey:
    "patZVy9c0JOBzwFOU.0600e75d034be9bb65d2b44fe640ca0da148907e261247a8d1d5213df661c633",
}).base("appZEnOdhQgxWXr07");
